<template>
  <div>
    <el-row type="flex" align="middle" :gutter="10">
      <el-col :span="16">
        <h3>Select Round</h3>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-form
      ref="form"
      :model="value"
      label-position="top"
    >
      <!-- Redio Button with Labels Redo Draw and Adjust Dates with v-model value.drawType -->
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Redo Draw Type">
            <el-radio-group v-model="value.drawType">
              <el-radio :label="0">Redo Draw</el-radio>
              <el-radio :label="1">
                Adjust Dates
                <el-tooltip class="item header-tooltip tooltip-1" effect="dark" placement="top-start">
                  <div slot="content">
                    <span>Adjust the round dates while keeping the match time, venue, and field.</span>
                  </div>
                  <i class="el-icon-info info"/>
                </el-tooltip>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="value.drawType === 0">
        <el-col :span="12">
          <!-- <el-form-item label="Redo Draw from Round">
            <el-input-number
              :controls="false"
              :min="minRound"
              :max="maxRound"
              :precision="0"
              v-model="value.fromRound"
            ></el-input-number>
          </el-form-item> -->
          <el-form-item label="Redo Draw from Round">
            <el-select
              v-model="value.fromRound"
              placeholder="Select a round"
              :disabled="value.fromRound === -1"
            >
              <el-option
                v-for="{ value, label } in roundsSelection"
                :key="value"
                :label="label"
                :value="value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="value.drawType === 1">
        <el-col :span="12">
          <el-form-item label="Adjust Round Dates From">
            <el-select
              v-model="value.fromRound"
              placeholder="Select a round"
              :disabled="value.fromRound === -1"
            >
              <el-option
                v-for="{ value, label } in roundsSelection"
                :key="value"
                :label="label"
                :value="value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button type="primary" @click="selectFields">
            <span>Select Fields</span>
            <el-tooltip class="tooltip">
              <div slot="content">When creating a draw the builder will use all fields that sit under a venue as a default, if you require specific fields to be used please nominate them here</div>
              <i class="el-icon-info info"/>
            </el-tooltip>
          </el-button>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="`Redo Draw Process${value.algorithm === 'prev-matches' ? ' (Create matches without teams that are matched in already created matches)' : ''}`">
            <el-select
            v-model="value.algorithm"
            placeholder="Select a process">
              <el-option v-for="{ value, label } in algorithms" :key="value" :label="label" :value="value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row> -->
    </el-form>
    <el-dialog
      title="Select Fields"
      :visible.sync="selectFieldsVisible"
      width="50%"
    >
      <el-col>
        <el-row v-for="{ _id, fields, name, fromName } in venuesAndFields" :key="_id">
          <h3>{{ name }} (From: {{ fromName }})</h3>
          <el-table-draggable>
            <el-table
              :data="fields"
              border
              style="width: 100%"
              empty-text="No fields available"
            >
              <el-table-column width="100"
                label="Include?"
              >
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.checked" />
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="Name"
              ></el-table-column>
            </el-table>
          </el-table-draggable>
        </el-row>
      </el-col>
    </el-dialog>
  </div>
</template>
<script>

import _, { } from 'lodash';
import {
  errormsg,
} from '@/utils/constants';
import ElTableDraggable from 'element-ui-el-table-draggable';

export default {
  props: ['value'],
  components: {
    ElTableDraggable
  },
  data() {
    return {
      competition: undefined,
      matches: [],
      minRound: 1,
      algorithms: [
        { value: 'original', label: 'Original' },
        { value: 'prev-matches', label: 'With Already Created Matches' },
      ],
      selectFieldsVisible: false,
      venuesAndFields: [],
    };
  },
  mounted() {
    this.$store.commit('loading', true);
    const { id } = this.$route.params;
    Promise.all([
      this.$http.get(`/assemble/api/v1/admin/competitions/${id}`),
      this.$http.get(`/assemble/api/v1/admin/matches/competition/${id}`)
    ])
      .then(([compRes, matchRes]) => {
        this.competition = compRes.data.data;
        this.matches = _.get(matchRes, 'data.data', []);
        // eslint-disable-next-line no-multi-assign
        this.value.fromRound = this.minRound = this.getMinRedoRound(this.competition, matchRes.data.data);
        this.$store.commit('loading', false);
      })
      .catch((err) => {
        console.log(err);
        // this.$message.error(err.response.data.message);
        this.$store.commit('loading', false);
      });
    this.getVenuesAndFields(id);
  },
  methods: {
    selectFields() {
      this.selectFieldsVisible = true;
    },
    async getVenuesAndFields(id) {
      try {
        const res = await this.$http.get(`/assemble/api/v1/admin/draws/competitions/${id}/venues`);
        const venues = res.data.data;
        console.log({
          venues
        });
        // eslint-disable-next-line no-restricted-syntax
        for (const venue of venues) {
          const fields = _.get(venue, 'fields', []);
          venue.fields = _.map(fields, (field) => ({
            ...field,
            checked: false
          }));
        }
        console.log({
          venues
        });
        this.venuesAndFields = venues;
        const venuesAndFields = _.get(this.competition, 'meta.venuesAndFields', []);
        if (!_.isEmpty(venuesAndFields)) {
          // Find venues and fields from venuesAndFields and assign fields
          // eslint-disable-next-line no-restricted-syntax
          for (const venue of venuesAndFields) {
            const venueFound = _.find(this.venuesAndFields, { _id: venue._id });
            if (venueFound) {
              venueFound.fields = venue.fields;
            }
          }
        }
        // this.venuesAndFields = res.data.data;
      } catch (error) {
        console.log('Error fetching venues and fields', error);
      }
    },
    getMinRedoRound(comp, matches, type = 'Regular') {
      // eslint-disable-next-line no-param-reassign
      matches = matches.filter((x) => x.round.type === type);
      // eslint-disable-next-line no-param-reassign
      matches = _.sortBy(matches, 'round.number');
      const currentRoundIndex = matches.findIndex((x) => x.status === 'pre-game'
                  && (!x.scoringEvents || !x.scoringEvents.length)
                  && (!x.playerMovements || !x.playerMovements.length));

      if (currentRoundIndex >= 0) {
        // Found current round number by match condition (status: pre-game, no scoringEvents, no playerMovements)
        let currentRound = matches[currentRoundIndex].round.number;
        // Check if previous round has no match, change current round to previous round (For cases if delete matches between rounds)
        while (currentRound > 1) {
          // eslint-disable-next-line no-loop-func
          const previousRoundMatch = matches.filter((x) => x.round.number === currentRound - 1);
          if (previousRoundMatch.length) break;
          else {
            // Previous round has no match, set current round to previous round
            currentRound -= 1;
          }
        }

        return currentRound;
      }

      /* For case if not found current round by previous logic */
      // No match in comp, return round 1
      if (!matches.length) {
        return 1;
      }

      // Find last match
      const lastMatch = matches[matches.length - 1];
      if (lastMatch) {
        const lastRound = lastMatch.round.number;
        if (lastRound === comp.regularSeasonRounds) {
          // All rounds completed
          return -1;
        }

        // Get current round by last round + 1 (For cases if delete all future matches)
        return lastRound + 1;
      }

      return 0;
    },
    roundRobin(teams, nor, startRound = 0) {
      const result = [];
      const teamSeeds = teams.map((team, index) => ({ team, seed: index + 1 }));
      // eslint-disable-next-line radix
      const half = parseInt(teams.length / 2);
      const group1 = teams.slice(0, half);
      let group2 = teams.slice(half, teams.length);
      group2 = group2.reverse();
      for (let index = 0; index < nor; index += 1) {
        if (index >= startRound) {
          for (let team = 0; team < half; team += 1) {
            // Flip home-away between rounds
            if (index % 2 !== 0) {
              result.push({
                round: (index + 1),
                away: { ...group1[team], seed: teamSeeds.find((t) => t.team.name === group1[team].name).seed },
                home: { ...group2[team], seed: teamSeeds.find((t) => t.team.name === group2[team].name).seed },
              });
            } else {
              result.push({
                round: (index + 1),
                home: { ...group1[team], seed: teamSeeds.find((t) => t.team.name === group1[team].name).seed },
                away: { ...group2[team], seed: teamSeeds.find((t) => t.team.name === group2[team].name).seed },
              });
            }
          }
        }
        // ROUND ROBIN CLOCKWISE CIRCLE
        const dontmove = group1.shift(); // DO NOT MOVE
        const lastElement = group1.pop(); // LAST MOVE DOWN
        const elementFirst = group2.shift(); // FIRST ELEMENT MOVE UP
        group1.unshift(elementFirst);
        group1.unshift(dontmove);
        group2.push(lastElement);
      }
      return result;
    },
    dateFormatter(r, c, val) {
      return this.moment(val).format('YYYY-MM-DD');
    },
    async submit() {
      this.value.venuesAndFields = this.venuesAndFields;
      const fieldsHasChecked = _.some(this.venuesAndFields, (venue) => _.some(venue.fields, (field) => field.checked));
      if (fieldsHasChecked) {
        this.value.venuesAndFieldsChecked = true;
      }
      const val = await this.$refs.form.validate().catch(() => {});
      if (!val) return false;

      if (!this.competition) {
        this.$message.error('Invalid competition');
        return false;
      }

      // get component props
      const {
        _id, name, hasPools, teams, pools, regularSeasonRounds, drawbuilder
      } = this.competition;

      // eslint-disable-next-line no-restricted-syntax
      for (const pool of pools) {
        // eslint-disable-next-line no-restricted-syntax
        for (const match of _.get(pool, 'matches', [])) {
          if (!_.get(match, 'homeTeam')) match.homeTeam = { _id: 'BYE', name: 'BYE' };
          if (!_.get(match, 'awayTeam')) match.awayTeam = { _id: 'BYE', name: 'BYE' };
        }
      }

      this.value.competition = {
        _id, name, hasPools, teams, pools, regularSeasonRounds, drawbuilder
      };

      // validate no. of teams should be gt 2
      if (teams.length <= 2) {
        this.$message.error(errormsg.draw_notenoughteam);
        return false;
      }

      // validate no. of teams in pools should be gt 2
      if (hasPools && pools && _.some(pools, (p) => p.teams.length <= 2)) {
        this.$message.error(errormsg.draw_notenoughteam);
        return false;
      }

      if (hasPools && pools && pools.length) {
        this.value.pools = pools;
      } else {
        this.value.pools = [{ name, teams }];
      }

      if (this.value.drawType === 1) {
        // Put matches in pools
        _.forEach(this.value.pools, (p) => {
          // eslint-disable-next-line no-param-reassign
          p.matches = _.filter(this.matches, (m) => m.round.type === 'Regular' && m.round.number >= this.value.fromRound);
        });
        // Map the date of the first match of each round
        _.forEach(this.value.pools, (p) => {
          // eslint-disable-next-line no-param-reassign
          p.roundDates = _.map(_.groupBy(p.matches, 'round.number'), (matches) => ({
            number: matches[0].round.number,
            time: matches[0].dateTime,
          }));
        });
        console.log({
          value: this.value,
          matches: this.matches,
        });
        // Disable eslint for loop
        // eslint-disable-next-line no-restricted-syntax
        for (const match of this.matches) {
          match.originalTime = _.cloneDeep(match.dateTime);
          match.originalVenue = _.cloneDeep(match.venue);
          match.originalMeta = _.cloneDeep(match.meta);
          match.originalData = _.cloneDeep(match);
        }
        this.value.originalMatches = _.cloneDeep(this.matches);
        this.value.originalFinalMatches = _.cloneDeep(_.filter(this.matches, (m) => m.round.type === 'Final'));
        this.value.matches = this.matches;
        this.$emit('selected', this.competition);
        this.$emit('input', this.value);
        return true;
      }

      const interPoolTeamMatches = _.get(this.competition, 'interPoolTeamMatches');
      if (interPoolTeamMatches) {
        const poolsLength = this.value.pools.length;
        let lastPoolIndex = poolsLength - 1;
        let lastPoolTeams = this.value.pools[lastPoolIndex].teams;
        let midpointLast = Math.ceil(lastPoolTeams.length / 2);
        let lastPoolTeamsFirstHalf = _.slice(lastPoolTeams, 0, midpointLast);
        let lastPoolTeamsSecondHalf = _.slice(lastPoolTeams, midpointLast);

        for (let i = 0; i < this.value.pools.length; i++) {
          if (poolsLength === i + 1) {
            break;
          }
          const midpointPool = Math.ceil(this.value.pools[i].teams.length / 2);
          const poolFirstHalf = _.slice(this.value.pools[i].teams, 0, midpointPool);
          const poolSecondHalf = _.slice(this.value.pools[i].teams, midpointPool);

          // eslint-disable-next-line no-param-reassign
          const ex1 = _.concat(lastPoolTeamsFirstHalf, poolSecondHalf);
          const ex2 = _.concat(poolFirstHalf, lastPoolTeamsSecondHalf);

          this.value.pools[i].teams = ex1;
          this.value.pools[lastPoolIndex].teams = ex2;

          lastPoolIndex = i;
          lastPoolTeams = this.value.pools[lastPoolIndex].teams;
          midpointLast = Math.ceil(lastPoolTeams.length / 2);
          lastPoolTeamsFirstHalf = _.slice(lastPoolTeams, 0, midpointLast);
          lastPoolTeamsSecondHalf = _.slice(lastPoolTeams, midpointLast);
        }
      }

      _.forEach(this.value.pools, (p) => {
        if (p.teams.length % 2 !== 0) p.teams.push({ _id: 'BYE', name: 'BYE ' });

        // eslint-disable-next-line no-param-reassign
        p.matches = _.map(this.roundRobin(p.teams, regularSeasonRounds, this.value.fromRound - 1), ({ round, away, home }) => ({
          homeTeam: _.pick(home, ['_id', 'name', 'seed']),
          awayTeam: _.pick(away, ['_id', 'name', 'seed']),
          round: { number: round }
        }));

        // calculate round dates
        const skips = _.sortBy(drawbuilder.skipDates, 'from');
        let recent;
        const nextDay = (index) => {
          // initial recent
          if (index === 0) recent = +this.moment(`${this.moment(drawbuilder.defaultStartDay).format('YYYY-MM-DD')} ${drawbuilder.defaultStartTime}`, 'YYYY-MM-DD HH:mm', true);
          // different days
          else if (drawbuilder.daysBetweenRounds > 0) recent = +this.moment(recent).add(drawbuilder.daysBetweenRounds, 'days');
          // same day
          else {
            // diff-time
            // eslint-disable-next-line no-lonely-if
            if (drawbuilder.isSameTimeRounds === false) {
              const startDay = this.moment(`${this.moment(recent).format('YYYY-MM-DD')} ${drawbuilder.defaultStartTime}`, 'YYYY-MM-DD HH:mm');
              const endDay = this.moment(`${this.moment(recent).format('YYYY-MM-DD')} ${drawbuilder.defaultEndTime}`, 'YYYY-MM-DD HH:mm');
              const xHours = endDay.diff(startDay, 'hours', true);
              const xGameADay = Math.round(xHours / drawbuilder.timeBetweenRounds);
              const matches = _.filter(p.matches, (m) => m.round.number === index);
              const xDay = Math.round(matches.length / xGameADay);
              recent = +this.moment(startDay).add(xDay, 'days');
              // recent = +this.moment(recent).add((matches.length % xGameADay) * drawbuilder.timeBetweenRounds, 'hours');

              const endTime = +this.moment(`${this.moment(recent).format('YYYY-MM-DD')} ${drawbuilder.defaultEndTime}`, 'YYYY-MM-DD HH:mm');
              if (recent >= endTime) recent = +this.moment(`${this.moment(recent).add(1, 'day').format('YYYY-MM-DD')} ${drawbuilder.defaultStartTime}`, 'YYYY-MM-DD HH:mm');
            } else {
              // same time
              recent = +this.moment(recent).add(drawbuilder.timeBetweenRounds, 'hours');
              // if hours in range
              const endDay = +this.moment(`${this.moment(recent).format('YYYY-MM-DD')} ${drawbuilder.defaultEndTime}`, 'YYYY-MM-DD HH:mm', true);
              // console.log(endDay);
              // if hours > defaultEndTime of recent day => next day
              if (recent >= endDay) recent = +this.moment(`${this.moment(recent).add(1, 'day').format('YYYY-MM-DD')} ${drawbuilder.defaultStartTime}`, 'YYYY-MM-DD HH:mm');
            }
          }
          _.forEach(skips, ({ from, to }) => {
            if (from <= recent && recent <= to) {
              recent = +this.moment(`${this.moment(to).format('YYYY-MM-DD')} ${drawbuilder.defaultStartTime}`, 'YYYY-MM-DD HH:mm').add(1, 'day');
            }
          });
          // console.log(this.moment(recent).format('DD/MM/YYYY HH:mm'));
          return recent;
        };
        // Run so that round date will start from index 0
        // Without this, variable "recent" will start from today instead of default start date
        _.forEach(_.range(0, this.value.fromRound - 1), (notInIndex) => {
          nextDay(notInIndex);
        });
        // eslint-disable-next-line no-param-reassign
        p.roundDates = _.range(this.value.fromRound - 1, regularSeasonRounds).map((r) => ({
          number: r + 1,
          time: nextDay(r)
        }));
      });

      this.$emit('selected', this.competition);
      this.$emit('input', this.value);

      return true;
    }
  },
  computed: {
    clearance() {
      return this.$store.getters['user/activeRoleType'];
    },
    maxRound() {
      return _.get(this.competition, 'regularSeasonRounds', 0);
    },
    roundsSelection() {
      return _.range(this.minRound, this.maxRound + 1).map((x) => ({ value: x, label: x }));
    },
  }
};
</script>

<style lang="scss" scoped>
 .tooltip {
  margin-left: 0.3rem;
  transform: translateY(1px);
 }

 .tooltip-1 {
  margin-left: 0.3rem;
  transform: translateY(2px);
}
</style>
